import Scriba from 'react-scriba';


export class DataJournalisation {

    static _onRemiseEnAttenteTraitementIF(idsJournalisations) {
        let objet = {
            "idsJournalisations": idsJournalisations
        };
        var url = "api/MAJDonnees/RemiseEnAttenteTraitementIF";
        var paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesJournalisations(filtreIdJournalisationMin, filtreIdJournalisationMax, filtreNomTable, filtreCreerPar, filtreFromDate, filtreToDate, filtreIdOperation, filtreIdLot,
        filtreIdContact,filtreIdReservation, filtreImmoFactory, filtrePriseEnCompteLe, filtreTraiteeLe, filtreErreurIF, filtreErreurEI, recherche, pageIndex, nbEnregistrementsParPage,
        tri, sortedColumn, isSortedDescending) {
        let objet = {
            "filtreIdJournalisationMin": filtreIdJournalisationMin == "" ? null : filtreIdJournalisationMin,
            "filtreIdJournalisationMax": filtreIdJournalisationMax == "" ? null : filtreIdJournalisationMax,
            "filtreNomTable": filtreNomTable,
            "filtreCreerPar": filtreCreerPar,
            "filtreFromDate": filtreFromDate,
            "filtreToDate": filtreToDate,
            "filtreIdOperation": filtreIdOperation,
            "filtreIdLot": filtreIdLot,
            "filtreIdContact": filtreIdContact,
            "filtreIdReservation": filtreIdReservation,
            "filtreImmoFactory": filtreImmoFactory,
            "filtrePriseEnCompteLe": filtrePriseEnCompteLe,
            "filtreTraiteeLe": filtreTraiteeLe,
            "filtreErreurIF": filtreErreurIF,
            "filtreErreurEI": filtreErreurEI,
            "recherche": recherche,
            "pageIndex": pageIndex,
            "nbEnregistrementsParPage": nbEnregistrementsParPage,
            "tri": tri,
            "sortedColumn": sortedColumn,
            "isSortedDescending": isSortedDescending
        };
        let url = 'api/Liste/ListeDesJournalisations';
        let paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }
}